/**
 * UX-023/UX-024: transient "you were sent here" pulse for banner deeplinks.
 *
 * Applies the `order-section-pulse` CSS class to a section element (or the
 * element resolved by id), restarting the animation cleanly if it is already
 * pulsing, and tears the class down when the animation ends. A timeout fallback
 * clears the class under `prefers-reduced-motion` (where no `animationend`
 * fires). No-op when the target is absent.
 */

export const ORDER_SECTION_PULSE_CLASS = 'order-section-pulse'

/** Belt-and-suspenders cleanup window (ms) covering the reduced-motion path. */
const PULSE_CLEANUP_MS = 1600

export function pulseElement(el: HTMLElement | null | undefined): void {
  if (!el) return
  el.classList.remove(ORDER_SECTION_PULSE_CLASS)
  // Force a reflow so removing then re-adding the class restarts the animation
  // even when the same target is pulsed twice in a row.
  void el.offsetWidth
  el.classList.add(ORDER_SECTION_PULSE_CLASS)
  el.addEventListener('animationend', () => el.classList.remove(ORDER_SECTION_PULSE_CLASS), {
    once: true,
  })
  window.setTimeout(() => el.classList.remove(ORDER_SECTION_PULSE_CLASS), PULSE_CLEANUP_MS)
}

export function pulseElementById(anchorId: string): void {
  pulseElement(document.getElementById(anchorId))
}
